// extracted by mini-css-extract-plugin
module.exports = {"contact":"Contact-module--contact--1lFRw","container":"Contact-module--container--1x48V"};